"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cookiePolicyAnalyticsMiddleware = void 0;
var cookiePolicyAnalyticsMiddleware = function (_a) {
    var policyGetter = _a.policyGetter;
    var segment = function (_a) {
        var _b, _c;
        var next = _a.next, payload = _a.payload;
        var marketing_consent = policyGetter().marketing_consent;
        var context = (_b = payload.obj.context) !== null && _b !== void 0 ? _b : {};
        var traits = (_c = context.traits) !== null && _c !== void 0 ? _c : {};
        var integrations = payload.obj.integrations
            ? payload.obj.integrations
            : {};
        traits.marketing_consent = marketing_consent;
        if (marketing_consent !== 'yes') {
            integrations.Everflow = false;
            integrations['Facebook conversion API dev'] = false;
            integrations['Facebook Conversions API'] = false;
            integrations['Facebook Pixel'] = false;
            integrations['Google Ads (Gtag)'] = false;
            integrations['TikTok FE'] = false;
            integrations['UTM & marketing params Amplitude'] = false;
            integrations['UTM & marketing params Destination'] = false;
        }
        payload.obj.context = context;
        payload.obj.integrations = integrations;
        next(payload);
    };
    return {
        segment: segment,
    };
};
exports.cookiePolicyAnalyticsMiddleware = cookiePolicyAnalyticsMiddleware;
//# sourceMappingURL=cookiePolicyAnalyticsMiddleware.js.map